import React, { useRef, useState, useEffect } from 'react'
import { Button } from 'carbon-components-react'
import {
  WorkspaceImport,
  Help,
  WatsonHealthTextAnnotationToggle,
  WatsonHealthBrushFreehand,
  ColorPalette,
  WatsonHealthRotate_360,
  Meter,
  NextOutline,
  PreviousOutline,
  ChatBot
} from '@carbon/icons-react'
import AudioRecorderUI from '../UIUtilsFiles/AudioRecorderUI'
import {
  CHAT_BOT,
  COLOR_PALETTE,
  HALFTIME,
  ONETIME,
  PREVIOUS_WORK,
  QUESTION,
  REPLAY,
  SKETCH_PAD,
  TEXT_AREA,
  TWOTIMES
} from '../constants'

function CanvasHeader(props) {
  const {
    totalTemplates,
    currentTemplate,
    savedAudioURL,
    strokeReplayStarted,
    smartCanvasData,
    isPreview,
    isReplayAvailable,
    isSecModalActive,
    Completed,
    isActive,
    isAudioPlaying,
    isPageNavigated
  } = props
  const {
    onNavigationClick,
    onModalItemClick,
    handleAudioURLChange,
    getCurrentSpeed,
    getRecordingStatus,
    onToastTrigger,
    onPaletteChange
  } = props

  const [currentSpeed, setcurrentSpeed] = useState(ONETIME)
  const [isReplayClicked, setIsReplayClicked] = useState(false)
  const [isChatBotAvailable, setIsChatBotAvailable] = useState(false)
  const [isRecording, setIsRecording] = useState(false)
  const [currentType, setCurrentType] = useState('')
  const [isPallete, setIsPallete] = useState('')

  useEffect(() => {
    if (!isSecModalActive) {
      setCurrentType('')
    }
  }, [isSecModalActive])

  useEffect(() => {
    if (isPageNavigated) {
      setIsReplayClicked(false)
      setCurrentType('')
    }
  }, [isPageNavigated])

  useEffect(() => {
    if (!strokeReplayStarted) {
      setIsReplayClicked(false)
      setCurrentType('')
    }
  }, [strokeReplayStarted])

  useEffect(() => {
    if (
      smartCanvasData &&
      smartCanvasData.ChatBotSettings &&
      smartCanvasData.ChatBotSettings !== ''
    ) {
      let chatBotData = JSON.parse(smartCanvasData.ChatBotSettings)
      if (chatBotData.topic && chatBotData.topic !== '') {
        setIsChatBotAvailable(true)
      } else {
        setIsChatBotAvailable(false)
      }
    }
  }, [smartCanvasData])

  useEffect(() => {
    getCurrentSpeed(currentSpeed)
  }, [currentSpeed])

  useEffect(() => {
    getRecordingStatus(isRecording)
  }, [isRecording])

  function renderReplayIcon() {
    return (
      <div className='header-expand-cont'>
        <Meter className='expand-icon-style' />
        <div
          className={
            currentSpeed === HALFTIME
              ? 'replay-speed-icon replay-speed-icon-selected'
              : 'replay-speed-icon'
          }
          style={{
            color: currentSpeed === HALFTIME ? '#ffffff' : '#000000',
            fontSize: '12px',
            fontFamily: 'Manrope'
          }}
          onClick={() => {
            setcurrentSpeed(HALFTIME)
          }}
        >
          0.5x
        </div>
        <div
          className={
            currentSpeed === ONETIME
              ? 'replay-speed-icon replay-speed-icon-selected'
              : 'replay-speed-icon'
          }
          style={{
            color: currentSpeed === ONETIME ? '#ffffff' : '#000000',
            fontSize: '12px',
            fontFamily: 'Manrope'
          }}
          onClick={() => {
            setcurrentSpeed(ONETIME)
          }}
        >
          1x
        </div>
        <div
          className={
            currentSpeed === TWOTIMES
              ? 'replay-speed-icon replay-speed-icon-selected'
              : 'replay-speed-icon'
          }
          style={{
            color: currentSpeed === TWOTIMES ? '#ffffff' : '#000000',
            fontSize: '12px',
            fontFamily: 'Manrope'
          }}
          onClick={() => {
            setcurrentSpeed(TWOTIMES)
          }}
        >
          2x
        </div>
      </div>
    )
  }

  useEffect(() => {
    onModalItemClick(currentType)
    if (currentType !== '') {
      if (currentType !== SKETCH_PAD && isPallete) {
        setIsPallete(false)
      }
    }
  }, [currentType])

  useEffect(() => {
    onPaletteChange(isPallete)
    if (isPallete) {
      if (currentType !== SKETCH_PAD) {
        setCurrentType('')
        setIsReplayClicked(false)
      }
    }
  }, [isPallete])

  return (
    <div className='canvas-header-item-cont'>
      <div className='temp-navigation-container'>
        <Button
          className='temp-header-button temp-button1-style'
          hasIconOnly
          size='default'
          renderIcon={PreviousOutline}
          tooltipAlignment='center'
          tooltipPosition='bottom'
          iconDescription='Previous page'
          onClick={() => {
            if (isRecording) {
              onToastTrigger('Recording is in progress.')
            } else {
              onNavigationClick('previous')
            }
          }}
        />

        <Button
          className='temp-header-button temp-button2-style'
          isExpressive={false}
          size='default'
        >
          {currentTemplate + ' / ' + totalTemplates}
        </Button>
        <Button
          className='temp-header-button temp-button1-style'
          hasIconOnly
          size='default'
          renderIcon={NextOutline}
          tooltipAlignment='center'
          tooltipPosition='bottom'
          iconDescription='Next page'
          onClick={() => {
            if (isRecording) {
              onToastTrigger('Recording is in progress.')
            } else {
              onNavigationClick('next')
            }
          }}
        />
      </div>
      <div className='temp-properties-container'>
        <Button
          className={
            currentType === CHAT_BOT
              ? 'temp-button3-style temp-button3-style-selected'
              : 'temp-button3-style'
          }
          hasIconOnly
          iconDescription={'Chat Bot'}
          renderIcon={ChatBot}
          tooltipAlignment='center'
          tooltipPosition='bottom'
          disabled={isPreview ? true : isChatBotAvailable ? false : true}
          onClick={() => {
            if (isRecording) {
              onToastTrigger('Recording is in progress.')
            } else {
              setCurrentType(CHAT_BOT)
            }
          }}
        />
        <Button
          className={
            currentType === PREVIOUS_WORK
              ? 'temp-button3-style temp-button3-style-selected'
              : 'temp-button3-style'
          }
          hasIconOnly
          iconDescription={'Previous Work'}
          renderIcon={WorkspaceImport}
          tooltipAlignment='center'
          tooltipPosition='bottom'
          disabled={isPreview ? true : false}
          onClick={() => {
            if (isRecording) {
              onToastTrigger('Recording is in progress.')
            } else {
              setCurrentType(PREVIOUS_WORK)
            }
          }}
        />
        <Button
          className={
            currentType === QUESTION
              ? 'temp-button3-style temp-button3-style-selected'
              : 'temp-button3-style'
          }
          hasIconOnly
          iconDescription={'Question'}
          renderIcon={Help}
          tooltipAlignment='center'
          tooltipPosition='bottom'
          //  disabled={disableClick ? true : false}
          onClick={() => {
            if (isRecording) {
              onToastTrigger('Recording is in progress.')
            } else {
              setCurrentType(QUESTION)
            }
          }}
        />
        <Button
          className={
            currentType === TEXT_AREA
              ? 'temp-button3-style temp-button3-style-selected'
              : 'temp-button3-style'
          }
          hasIconOnly
          iconDescription={'Text Area'}
          renderIcon={WatsonHealthTextAnnotationToggle}
          tooltipAlignment='center'
          tooltipPosition='bottom'
          disabled={isPreview ? true : false}
          onClick={() => {
            if (isRecording) {
              onToastTrigger('Recording is in progress.')
            } else {
              setCurrentType(TEXT_AREA)
            }
          }}
        />
        <Button
          className={
            currentType === SKETCH_PAD
              ? 'temp-button3-style temp-button3-style-selected'
              : 'temp-button3-style'
          }
          hasIconOnly
          iconDescription={'Sketch Pad'}
          renderIcon={WatsonHealthBrushFreehand}
          tooltipAlignment='center'
          tooltipPosition='bottom'
          disabled={isPreview ? true : false}
          onClick={() => {
            if (isRecording) {
              onToastTrigger('Recording is in progress.')
            } else {
              setCurrentType(SKETCH_PAD)
            }
          }}
        />
        {!isReplayClicked ? (
          <Button
            className={
              currentType === REPLAY
                ? 'temp-button3-style temp-button3-style-selected'
                : 'temp-button3-style'
            }
            hasIconOnly
            iconDescription={'Replay Strokes'}
            renderIcon={WatsonHealthRotate_360}
            tooltipAlignment='center'
            tooltipPosition='bottom'
            disabled={isPreview ? true : isReplayAvailable ? false : true}
            onClick={() => {
              if (isRecording) {
                onToastTrigger('Recording is in progress.')
              } else {
                setIsReplayClicked(true)
                setCurrentType(REPLAY)
              }
            }}
          />
        ) : (
          renderReplayIcon()
        )}
        <AudioRecorderUI
          isPreview={isPreview}
          initialAudioURL={savedAudioURL}
          onAudioURLChange={handleAudioURLChange}
          getRecordingStatus={(recordingStatus) => {
            setIsRecording(recordingStatus)
          }}
          Completed={Completed}
          isActive={isActive}
          isAudioPlaying={isAudioPlaying}
        />

        <Button
          className={
            isPallete
              ? 'temp-button3-style temp-button3-style-selected'
              : 'temp-button3-style'
          }
          hasIconOnly
          iconDescription={'Color Palette'}
          renderIcon={ColorPalette}
          tooltipAlignment='center'
          tooltipPosition='bottom'
          disabled={
            isPreview ? true : Completed === 1 || !isActive ? true : false
          }
          onClick={() => {
            if (isRecording) {
              onToastTrigger('Recording is in progress.')
            } else {
              setIsPallete((prev) => !prev)
              // setCurrentType(COLOR_PALETTE)
            }
          }}
        />
      </div>
    </div>
  )
}
export { CanvasHeader }
